import React, { useState, useEffect, useRef } from 'react';
import './LoadingView.css';

function LoadingView({ title, subtitle, onFinish, duration = 2000 }) {
  const [progress, setProgress] = useState(0);
  const timerRef = useRef(null);

  useEffect(() => {
    setProgress(0);
    const intervalTime = 20;
    const steps = duration / intervalTime;
    const stepSize = 100 / steps;

    timerRef.current = setInterval(() => {
      setProgress((prev) => {
        const next = prev + stepSize;
        if (next >= 100) {
          clearInterval(timerRef.current);
          // 稍微延迟一下，让用户看到100%
          setTimeout(() => {
            if (onFinish) onFinish();
          }, 200);
          return 100;
        }
        return next;
      });
    }, intervalTime);

    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [duration, onFinish]);

  return (
    <div className="loading-view-container">
      <div className="generating-view">
        <div className="generating-icon-container">
          <i className="fas fa-compact-disc generating-icon spin"></i>
          <div className="generating-wave"></div>
        </div>
        <h2 className="generating-title">{title}</h2>
        <p className="generating-subtitle">{subtitle}</p>
        
        <div className="progress-container">
          <div className="progress-bar-bg">
            <div 
              className="progress-bar-fill" 
              style={{ width: `${progress}%` }}
            ></div>
          </div>
          <span className="progress-text">{Math.floor(progress)}%</span>
        </div>
      </div>
    </div>
  );
}

export default LoadingView;